// FE #746: a request the browser dropped never reached a server verdict, so it must
// read as a retryable connection problem rather than as a refusal.
export const CHAT_CONNECTION_ERROR_MESSAGE = 'Connection problem. Check your connection and retry.';

export class ChatConnectionError extends Error {
  constructor(message = CHAT_CONNECTION_ERROR_MESSAGE) {
    super(message);
    this.name = 'ChatConnectionError';
    this.connectionError = true;
  }
}

export function isChatConnectionError(error) {
  return Boolean(error?.connectionError);
}

export function isNetworkFailureResponse(response) {
  return Boolean(response?.networkError);
}

// One key per user send, reused by every retry of that send: the backend dedups
// chat turns on (user, account, session, idempotency_key), so a retry after a lost
// response returns the original turn instead of creating and charging a second one.
export function createChatIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `chat-send-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

function userTurnCount(messages, text) {
  return (Array.isArray(messages) ? messages : [])
    .filter((message) => message?.role === 'user' && String(message.content || '').trim() === text)
    .length;
}

// History messages carry no idempotency key, so a landed turn shows up as one more
// user message with this text than the thread held before the send.
export function sendTurnLanded(sessionMessages, priorMessages, text) {
  const normalized = String(text || '').trim();
  return userTurnCount(sessionMessages, normalized) > userTurnCount(priorMessages, normalized);
}
